import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

export default function TermsOfService() {
  return (
    <div className="min-h-screen text-gray-800 px-6">
        <Header />
        <div className="max-w-3xl mx-auto bg-white p-8 my-[3rem] rounded-lg shadow-md">
            <h1 className="text-2xl sm:text-3xl font-semibold mb-4">
            Terms of Service
            </h1>
            <p className="text-sm text-gray-500 mb-6">
            Takamori Robot<br />
            Effective Date: 11/09/2025
            </p>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">1. Acceptance</h2>
            <p>
                By using our website and services at www.takamorirobot.com, you agree to these Terms
                and our Privacy Policy. If you do not agree, please discontinue use.
            </p>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">2. Use of Service</h2>
            <ul className="list-disc pl-5">
                <li>Follow applicable laws and respect others’ rights.</li>
                <li>Do not interfere with or misuse the Service.</li>
            </ul>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">3. Account & Access</h2>
            <p>
                You are responsible for maintaining confidentiality of your credentials and
                all activity under your account.
            </p>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">4. Intellectual Property</h2>
            <p>
                All content on the Service belongs to us or our licensors. You may not reuse
                or distribute it without permission.
            </p>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">5. Limitation of Liability</h2>
            <p>
                The Service is provided “as is” without warranties. We are not liable for
                indirect or consequential damages arising from its use.
            </p>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">6. Governing Law</h2>
            <p>
                These Terms are governed by the laws of Tacoma, WA. Disputes shall be
                resolved in the courts of Tacoma, WA.
            </p>
            </section>

            <section>
            <h2 className="font-semibold mb-1">7. Contact</h2>
            <p>
                For any questions, contact us at{" "}
                <span className="font-medium">joseph@takamorirobot.com</span>.
            </p>
            </section>
        </div>
        <Footer />
    </div>
  );
}
